import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Modals from './Modals';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const Table = ({
  title,
  subtitle,
  questionText,
  expand,
  setExpand,
  questionStandards,
  questionResponses,
  studentCount,
  index,
  isPrint,
  responseCount
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [expandCheck, setExpandCheck] = React.useState(false);

  useEffect(() => {
    setExpand(expandCheck);
  }, [expandCheck]);

  const manageExpand = (e, id) => {
    const currentTargetId = parseInt(e.currentTarget.id);
    if (currentTargetId === id) setExpandCheck(!expandCheck);
  };

  return (
    <div className="mt-5">
      {isPrint ? (
        <p className={responseCount===0?'tbl-title':'d-none'}>
          {title + ' '}
          <p className="tbl-subtitle">({subtitle})</p>
        </p>
      ) : (
        <div className="d-flex justify-content-between">
          <p className="table_title">
            {questionText != null ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip className="custom-tooltip">
                    <div dangerouslySetInnerHTML={{ __html: questionText }}></div>
                  </Tooltip>
                }>
                <p className="tbl-title">
                  {title + ' '}
                  <p className="tbl-subtitle">({subtitle})</p>
                </p>
              </OverlayTrigger>
            ) : (
              <p className="tbl-title">
                {title + ' '}
                <p className="tbl-subtitle">({subtitle})</p>
              </p>
            )}
          </p>
          {responseCount > 0 ? (
            <button
              id={index}
              style={{
                background: '#e1eeff',
                color: 'rgba(84, 113, 200, 0.6)',
                width: '30px',
                height: '30px',
                textAlign: 'center',
                border: 'none',
                marginLeft: '10px'
              }}
              className="rounded-circle"
              onClick={(e) => manageExpand(e, index)}>
              {expandCheck ? (
                <FontAwesomeIcon icon={faChevronDown} />
              ) : (
                <FontAwesomeIcon icon={faChevronRight} />
              )}
            </button>
          ) : (
            <button
              id={index}
              style={{
                background: '#e1eeff',
                color: 'rgba(84, 113, 200, 0.6)',
                width: '30px',
                height: '30px',
                textAlign: 'center',
                border: 'none',
                marginLeft: '10px',
                cursor: 'default'
              }}
              className="rounded-circle">
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          )}
        </div>
      )}
      {(!isPrint ? expandCheck : expand) && (
        <>
          {questionResponses.length > 0 ? (
            <div>
              <div className="row gap-5">
                <table className="answer_report_tbl col-md-5">
                  {isPrint && 
                  <tr>
                    <th colSpan={4}>
                      <p className="tbl-title">
                        {title + ' '}
                        <p className="tbl-subtitle">({subtitle})</p>
                      </p>
                    </th>
                  </tr>
                  }
                  <tr className="table-head">
                    <th>Response</th>
                    <th>Count</th>
                    <th>Percent</th>
                    <th></th>
                  </tr>
                  {questionResponses?.map((questionResponse) => {
                    return (
                      <>
                        <tr className="table-body">
                          <td>
                            {questionResponse?.answerText != null ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip className="custom-tooltip">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: questionResponse?.answerText
                                      }}></div>
                                  </Tooltip>
                                }>
                                {questionResponse?.isCorrect === true ? (
                                  <p className="correct-answer">
                                    {questionResponse.response + ' (Correct)'}
                                  </p>
                                ) : (
                                  <p>{questionResponse.response}</p>
                                )}
                              </OverlayTrigger>
                            ) : (
                              <p>{questionResponse.response}</p>
                            )}
                          </td>
                          <td>{questionResponse.count}</td>
                          <td>{Math.round((questionResponse.count / studentCount) * 100)}</td>
                          <td>
                            <CircularProgressbar
                              value={Math.round((questionResponse.count / studentCount) * 100)}
                              text={`${Math.round((questionResponse.count / studentCount) * 100)}%`}
                              strokeWidth={12}
                              styles={buildStyles({
                                pathColor: '#FB5F5F',
                                textColor: '#525252',
                                trailColor: '#d6d6d6'
                              })}
                            />
                          </td>
                        </tr>
                        <tr className="line"></tr>
                      </>
                    );
                  })}
                </table>
                <div className="col-md-6">
                  <div className={isPrint?'question_standard_info_dup':'question_standard_info'}>
                    <b>Question Standards</b>
                    {questionStandards.map((questionStandard) => (
                      <div key={questionStandard.id}>
                        <p>{questionStandard.standardName}</p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: questionStandard.standardDescription
                          }}></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}
      <Modals isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default Table;
